<template>
  <b-server-table
    :key="tableRenderKey"
    :filter-props="{
      filterMap: [{ key: 'search' }],
    }"
    :headers="appointmentTypeHeaders"
    :request-func="getItems">
    <template #action-button>
      <v-btn @click="openCreateDialog">
        <v-icon class="mr-1">mdi-plus</v-icon>
        <span>Створити призначення</span>
      </v-btn>
    </template>
    <template #item.name="{ item }">
      {{ item?.name || '---' }}
    </template>
    <template #item.actions="{ item }">
      <b-action-menu
        :actions="[
          {
            title: 'Редагувати',
            action: () => openUpdateDialog(item),
            icon: 'mdi-pencil',

            iconProps: {
              color: 'blue-darken-3',
            },
          },
          {
            title: 'Видалити',
            action: () => deleteItem(item.id),
            icon: 'mdi-delete-forever',
            listItemProps: {
              class: 'text-error',
            },
            iconProps: {
              color: 'error',
            },
          },
        ]">
      </b-action-menu>
    </template>
  </b-server-table>
</template>
<script lang="ts">
import { ref } from 'vue'
import { axios } from '@/plugins'
import {
  urlCreateOrgAppointmentType,
  urlDeleteOrgAppointmentType,
  urlGetOrgAppointmentTypes,
  urlUpdateOrgAppointmentType,
} from '@/utils/urls'
import { openDialog } from '@/dialog'
import { BActionMenu, BServerTable } from 'best-modules/components/index'
import { Query } from 'best-modules/utils'

type OrgAppointmentType = {
  id: number
  name: string
}

export default {
  name: 'OrgAppointmentTypeList',
  components: { BActionMenu, BServerTable },
  data: () => ({
    appointmentTypeHeaders: [
      { key: 'name', title: 'Назва' },
      { key: 'actions', title: 'Дії', sortable: false, align: 'end' as const },
    ],
  }),
  setup() {
    const tableRenderKey = ref(1)

    const getItems = (query: Query) => {
      return axios
        .get(urlGetOrgAppointmentTypes({ ...query, paginate: true }))
        .then(res => res.data)
    }

    const entityConfig = {
      label: 'Тип призначення',
      hasDescription: false,
      directoryName: 'orgAppointmentTypes',
      urlCreate: urlCreateOrgAppointmentType,
      urlUpdate: urlUpdateOrgAppointmentType,
    }

    const openCreateDialog = () => {
      openDialog({
        name: 'OrgDirectoryItem',
        action: 'create',
        params: {
          title: 'Створити тип призначення',
          submitLabel: 'Створити',
          cb: () => (tableRenderKey.value += 1),
        },
        dialogData: { entityConfig },
      })
    }

    const openUpdateDialog = (item: OrgAppointmentType) => {
      openDialog({
        name: 'OrgDirectoryItem',
        action: 'update',
        params: {
          title: 'Редагувати тип призначення',
          submitLabel: 'Змінити',
          cb: () => (tableRenderKey.value += 1),
        },
        dialogData: { entityConfig, itemData: item },
      })
    }

    const deleteItem = (id: number) => {
      return axios.delete(urlDeleteOrgAppointmentType(id)).then(() => {
        tableRenderKey.value += 1
      })
    }

    return {
      getItems,
      openCreateDialog,
      openUpdateDialog,
      deleteItem,
      tableRenderKey,
    }
  },
}
</script>
